module.exports = __webpack_public_path__ + "img/bg_row_v1.1df5b516.svg";